import React from 'react';
import ReactDOM from 'react-dom';
import './theme/index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { isChunkLoadError, tryReloadOnChunkError } from './utils/chunkErrorUtils';

// 1) Script load failures: browser fires 'error' with event.error = null, event.target = <script>
window.addEventListener('error', (event) => {
  const isScriptLoadError =
    event.target?.tagName === 'SCRIPT' &&
    event.target?.src &&
    (event.target.src.includes('/static/js/') || event.target.src.includes('.chunk.') || /\.js(\?|$)/.test(event.target.src));
  const isChunkErrorFromException = event.error && isChunkLoadError(event.error);

  if (isScriptLoadError || isChunkErrorFromException) {
    tryReloadOnChunkError(event.error || event.target?.src);
    event.preventDefault();
    event.stopPropagation();
    return true;
  }
}, true);

// 2) Unhandled promise rejections from dynamic import() (e.g. before React consumes them)
window.addEventListener('unhandledrejection', (event) => {
  if (isChunkLoadError(event.reason)) {
    if (tryReloadOnChunkError(event.reason)) {
      event.preventDefault();
    }
  }
});

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
